import React from 'react';
import { Modal } from 'react-bootstrap';

const UpdateGeneralServiceDetails = ({ editGeneralServiceModal, setEditGeneralServiceModal, generalServiceDetailsFormData, handleSubmitUpdateGeneralServiceDetails, handleChangeGeneralServiceFormData }) => {
    return (
        <>
            <Modal
                centered
                show={editGeneralServiceModal}
                onHide={() => setEditGeneralServiceModal(false)}
                size={"lg"}
            >
                <div className="modal-header">
                    <h3 className="modal-title" id="exampleModalLabel">Update General Service Details</h3>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={() => setEditGeneralServiceModal(false)}
                    ></button>
                </div>
                <div className="modal-body">
                    <form onSubmit={handleSubmitUpdateGeneralServiceDetails}>
                        <div className="row">
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="serviceDetailName" className="col-form-label">
                                        Name:
                                    </label>
                                    <input
                                        name="serviceDetailName"
                                        value={generalServiceDetailsFormData?.serviceDetailName}
                                        onChange={(e) => handleChangeGeneralServiceFormData(e)}
                                        type="text"
                                        className="form-control"
                                        placeholder="General Service Name"
                                        readOnly
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="pt_price" className="col-form-label">
                                        Patient Price:
                                    </label>
                                    <input
                                        type="text"
                                        name="pt_price"
                                        value={generalServiceDetailsFormData.pt_price}
                                        onChange={(e) => handleChangeGeneralServiceFormData(e)}
                                        className="form-control"
                                        placeholder="Patient Price"
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="client_price" className="col-form-label">
                                        Client Price:
                                    </label>
                                    <input
                                        type="text"
                                        name="client_price"
                                        value={generalServiceDetailsFormData.client_price}
                                        onChange={(e) => handleChangeGeneralServiceFormData(e)}
                                        className="form-control"
                                        placeholder="Client Price"
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="tax" className="col-form-label">
                                        Tax:
                                    </label>
                                    <input
                                        type="text"
                                        name="tax"
                                        value={generalServiceDetailsFormData.tax}
                                        onChange={(e) => handleChangeGeneralServiceFormData(e)}
                                        className="form-control"
                                        placeholder="Tax"
                                    />
                                </div>
                            </div>
                            <div className="col-xl-6">
                                <div className="form-group">
                                    <label htmlFor="status" className="col-form-label">
                                        Status:
                                    </label>
                                    <div className='d-flex align-items-center gap-4'>
                                        {["Active", "Inactive", "Deleted"].map((status) => (
                                            <div className="form-check me-3" key={status}>
                                                <input
                                                    className="form-check-input"
                                                    type="radio"
                                                    name="status"
                                                    id={status.toLowerCase()}
                                                    value={status}
                                                    checked={generalServiceDetailsFormData.status === status}
                                                    onChange={(e) => handleChangeGeneralServiceFormData(e)}
                                                />
                                                <label
                                                    className="form-check-label"
                                                    htmlFor={status.toLowerCase()}
                                                >
                                                    {status}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={() => setEditGeneralServiceModal(false)}
                            >
                                Close
                            </button>
                            <button type="submit" className="btn btn-success">Update</button>
                        </div>
                    </form>
                </div>
            </Modal>
        </>
    )
};

export default UpdateGeneralServiceDetails;